/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    // const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");
    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-thin, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionInit = function () {
  const accordionItems = document.querySelectorAll(".accordion--default .accordion__question");

  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
    })
  );
}; // accordionInit();
accordionInit();

/*  ==========================================================================
    GENERAL - accordion with media
    ========================================================================== */

const accordionMediaInit = function () {
  const accordionModules = document.querySelectorAll(".module--accordion");

  if (!accordionModules) {
    return;
  }

  accordionModules.forEach(accordion => {
    const accordionQuestion = accordion.querySelectorAll(".accordion__question");
    const accordionMedia = accordion.querySelector(".accordion__media");

    accordionQuestion.forEach(item =>
      item.addEventListener("click", function () {
        const accordionItem = item.closest(".accordion__item");

        let currentItem = accordion.querySelector(".accordion__item.accordion__item--open");

        if (currentItem && currentItem !== accordionItem) {
          currentItem.classList.remove("accordion__item--open");
        }

        accordionItem.classList.toggle("accordion__item--open");

        if (accordionMedia && accordionItem.dataset.media !== undefined) {
          let activiElemID = accordionItem.dataset.media;

          console.log(activiElemID);

          accordion.querySelector(".media__item.active").classList.remove("active");
          accordion.querySelector('.media__item[data-id="' + activiElemID + '"]').classList.add("active");
        }
      })
    );
  });
}; // accordionInit();
accordionMediaInit();

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    new Plyr(plyr, {
      controls: ["play", "progress", "mute", "current-time"],
      hideControls: true,
      invertTime: false,
      tooltips: { controls: false, seek: false }
    });
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
      Audio Player
    ========================================================================== */

let audioplayer = false;

const audioPlyrInit = function () {
  const plyr = document.querySelector(".podcast__plyr");
  const plyrWrap = document.querySelector(".podcast__player");

  if (!plyr) {
    return;
  }

  const controls = `
      <div class="plyr__controls">
          <button type="button" class="plyr__control plyr__control--rewind" data-plyr="rewind">
              <span class="fal fa-backward-fast"></span>
          </button>
          <button type="button" class="plyr__control plyr__control--play" aria-label="Play, {title}" data-plyr="play">
              <span class="icon--not-pressed fas fa-play"></span>
              <span class="icon--pressed fas fa-pause"></span>
          </button>
          <button type="button" class="plyr__control plyr__control--forward" data-plyr="fast-forward">
              <span class="fal fa-forward-fast"></span>
          </button>
          <div class="player__times">
            <div class="plyr__time plyr__time--current text-sml" aria-label="Current time">00:00</div>
            <div class="plyr__time plyr__time--duration text-sml" aria-label="Duration">00:00</div>
          </div>
          <div class="plyr__progress__container">
            <div class="plyr__progress">
                <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
                <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
            </div>
          </div>
      </div>
      `;

  let podcastPlyr = new Plyr(plyr, { controls });

  plyrWrap.classList.add("loaded");

  // Adding the duration manually as it was not loading

  podcastPlyr.on("ready", event => {
    const instance = event.detail.plyr;

    const trySetDuration = setInterval(() => {
      const duration = instance.duration;
      const durationEl = document.querySelector(".plyr__time--duration");

      if (duration && durationEl) {
        durationEl.textContent = formatTime(duration);
        clearInterval(trySetDuration);
      }
    }, 300);
  });
};

audioPlyrInit();

function formatTime(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  if (h > 0) {
    return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  } else {
    return `${m}:${String(s).padStart(2, "0")}`;
  }
}

/*  ==========================================================================
    FAKE load more on single event
    ========================================================================== */
const eventLoadmoreBtn = document.querySelector(".showhidden__loadmore"),
  eventContainer = document.querySelector(".related-events__container");

if (eventLoadmoreBtn && eventContainer) {
  eventLoadmoreBtn.addEventListener("click", function () {
    const events = eventContainer.querySelectorAll(".event");

    let requests = [...events].map(item => {
      return new Promise(resolve => {
        item.style.display = "block";
        item.classList.add("effect", "effect--default");
        // console.log("done with", item);
        resolve("Success!");
      });
    });

    Promise.all(requests).then(() => {
      eventLoadmoreBtn.style.display = "none";
      effectsInit();
    });
  });
}

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelectorAll(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPosts = function () {
  const button = this;

  let data = {};
  let isCustomQuery = false;
  let loadmoreContainerCustom = "";

  if (this.dataset && this.dataset.customQuery) {
    let customQueryArgs = window[this.dataset.customQuery];
    loadmoreContainerCustom = document.querySelector(".loadmore-" + button.dataset.customQuery);
    isCustomQuery = true;
    data = {
      action: "loadmore",
      query: customQueryArgs.posts, // that's how we get params from wp_localize_script() function
      page: customQueryArgs.current_page,
      iseventrow: button.dataset.event && button.dataset.event === "row" ? true : false
    };
  } else {
    data = {
      action: "loadmore",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function
      page: php_variables.current_page,
      iseventrow: button.dataset.event && button.dataset.event === "row" ? true : false
    };
  }

  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        if (isCustomQuery) {
          let customQueryArgs = window[button.dataset.customQuery];
          loadmoreContainerCustom.innerHTML = loadmoreContainerCustom.innerHTML + data;
          customQueryArgs.current_page++;
          // if last page, remove the button..
          if (parseInt(customQueryArgs.current_page) === parseInt(customQueryArgs.max_page)) {
            button.remove();
          }
        } else {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
          php_variables.current_page++;
          // if last page, remove the button..
          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            button.remove();
          }
        }

        let showingCounter = loadmoreContainer.childElementCount;
        const countResultsBar = document.querySelector(".posts__searchresult");
        if (countResultsBar) {
          countResultsBar.innerText = `Showing ${showingCounter} ${showingCounter === 1 ? "result" : "results"}`;
        }

        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        effectsInit();
      } else {
        button.remove(); // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  loadmoreBtn.forEach(el => el.addEventListener("click", loadmoreLoadPosts));
}; // loadmoreInit();
loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effectsInit = function () {
  const effects = document.querySelectorAll(".effect");

  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit();

/*  ==========================================================================
    Front Page Animation
    ========================================================================== */

const frontpageHeroAnimation = document.querySelector(".logoanimation");

function frontpageHeroInit() {
  if (!frontpageHeroAnimation) {
    return;
  }

  const frontpageHero = document.querySelector(".pageheader--frontpage");

  // On page load, check if animation has already run
  if (!sessionStorage.getItem("animationPlayed")) {
    sessionStorage.setItem("animationPlayed", "true");
    frontpageHero.classList.add("loaded");

    // Run after DOM is ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", waitForVimeo);
    } else {
      waitForVimeo();
    }
  } else {
    frontpageHero.classList.add("noanimation");
  }

  function init() {
    // Timer promise (3 seconds)
    const delay = new Promise(resolve => setTimeout(resolve, 1500));

    // 👉 Vimeo ready promise
    const iframe = document.querySelector(".pageheader__bg iframe");
    const player = new Vimeo.Player(iframe);

    const videoReady = new Promise(resolve => {
      player.on("loaded", resolve);
    });

    // 👉 Wait for BOTH conditions
    Promise.all([delay, videoReady]).then(() => {
      frontpageHero.classList.add("loaded-1");

      setTimeout(() => {
        frontpageHero.classList.add("loaded-2");

        setTimeout(() => {
          frontpageHero.classList.add("loaded-3");

          setTimeout(() => {
            frontpageHero.classList.add("loaded-4");
          }, 1500);
        }, 1500);
      }, 1500);
    });
  }

  function waitForVimeo() {
    if (typeof Vimeo !== "undefined") {
      init();
    } else {
      setTimeout(waitForVimeo, 50);
    }
  }
}

frontpageHeroInit();

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const logosMarquees = document.querySelectorAll(".logomarquee__marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const logosMarqueeinit = function () {
  if (logosMarquees.length <= 0) {
    return;
  }

  logosMarquees.forEach(elem => {
    window.addEventListener("resize", function () {
      marquee__resize(elem);
    });

    // Repeating Logos and Text to make sure it fills the width of the view port
    const viewportWidth = window.innerWidth;
    const minWidth = (viewportWidth * 1) / 2;

    const tiles = elem.querySelectorAll(".marquee__tile");
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;

    // Wrapping the tiles
    elem.innerHTML = "<div class='" + innerClass + "'>" + elem.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = elem.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = elem.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    elem.appendChild(repeatingTextClone);
    elem.appendChild(repeatingTextClone2);

    // Force all lazy images within carousels to load immediately, otherwise they wont load
    // const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    // marquee_lazyimgs.forEach(img => {
    //   LazyLoad.load(img);
    //   console.log(img);
    // });

    // Setup animation times
    marquee__resize(elem);

    // Once everything is set up, add "loaded" class
    elem.classList.add(elClass + "--loaded");
  });
};

// Defer loading this code until after page load
window.addEventListener("load", logosMarqueeinit);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarouselInit = function () {
  const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;
    const animation = elem.dataset.animation ? true : false;

    const activeItem = elem.dataset.activeitem ? true : false;

    var owlCarousel = $(elem)
      .owlCarousel({
        autoplay: autoplay,
        autoplayTimeout: autoplayTimeout,
        loop: loop,
        nav: nav,
        dots: dots,
        animateIn: animation ? "fadeIn" : false,
        items: 1,
        navText: ["<i class='fa-light fa-arrow-left'></i>", "<i class='fa-light fa-arrow-right'></i>"],
        responsive: responsiveArray,
        startPosition: slides.length,
        autoHeight: autoHeight,
        onInitialized: function (event) {
          lazyLoadInstance.update();
          Waypoint.refreshAll();

          // Used in the Campus Status carousel to show the current status
          const owlInstance = event.relatedTarget;

          if (activeItem) {
            let $current = $(event.target).find(".step--current");
            if ($current.length) {
              let index = $current.closest(".owl-item").index();
              owlInstance.to(index, 0);
            }
          }
        }
      })
      .on("changed.owl.carousel", function (event) {
        let indexMenu = elem.parentNode.querySelector(".owlindex__current");
        if (indexMenu) {
          let currentIndex = event.item.index + 1;

          currentIndex = currentIndex < 10 ? "0" + currentIndex : currentIndex;
          indexMenu.textContent = currentIndex;
        }
      });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit();

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
    Feature Carousel - Used on the Content Hub
    ========================================================================== */

const postsCarouselInit = function () {
  const postsCarousels = document.querySelectorAll(".featureposts .owl-carousel");

  if (postsCarousels.length <= 0) {
    return;
  }

  postsCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".post");
    if (!slides) {
      return;
    }

    let postsOwlCarousel = $(postsCarousels)
      .owlCarousel({
        items: 1,
        margin: 0,
        autoplay: true,
        autoplayTimeout: 5000,
        loop: true,
        rewind: true,
        dots: false,
        nav: true,
        navText: ["<i class='fa-regular fa-arrow-left'></i>", "<i class='fa-regular fa-arrow-right'></i>"],
        onInitialized: function () {},
        onTranslate: function (event) {
          // refreshing lazyload to target the clone images
          lazyLoadInstance.update();
        }
      })
      .on("changed.owl.carousel", function () {
        postsOwlCarousel.trigger("stop.owl.autoplay"); // stop first
        postsOwlCarousel.trigger("play.owl.autoplay", [5000]); // restart with timeout
      });
  });
};

postsCarouselInit();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      body.classList.remove(mobnavOpenclass);
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
	NAVIGATION - mobnav dropdowns
	========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
	NAVIGATION - Search
	========================================================================== */

// Search open & close
const searchNav = document.querySelector(".siteheader__search");
const searchToggle = document.querySelector(".search-toggle");
const searchInput = document.querySelector(".siteheader__search .searchform__input input");

// Close search modal when clicked elsewhere in the document
const clickedOusideSearch = function (e) {
  if (!searchNav.classList.contains("siteheader__search--open")) {
    return;
  }

  var isClickInsideElement =
    searchNav.contains(e.target) || searchToggle === e.target || searchToggle.contains(e.target);

  if (!isClickInsideElement) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  }
}; // clickedOusideSearch();

// Toggle search modal window
const searchModalToggle = function (e) {
  e.preventDefault();
  if (searchNav.classList.contains("siteheader__search--open")) {
    searchNav.classList.remove("siteheader__search--open");
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  } else {
    searchNav.classList.add("siteheader__search--open");
    searchInput.focus();
    body.addEventListener("mouseup", clickedOusideSearch, false);
  }
}; // searchModalToggle();

const searchModalInit = function () {
  if (!searchNav || !searchToggle) {
    return;
  }
  searchToggle.addEventListener("click", searchModalToggle);
}; // searchModalInit();

searchModalInit();

/*  ==========================================================================
    NAVIGATION - hide announcement banner on scroll 
    ========================================================================== */

const announcementBar = document.querySelector(".announcement"),
  announcementCloseBtn = document.querySelector(".announcement__close"),
  siteheader = document.querySelector(".siteheader:not(.siteheader--padder)");

const announcementBarHide = function () {
  if (window.scrollY > 50) {
    siteheader.classList.add("siteheader--hideannouncement");
    announcementBar.style.marginTop = `-${announcementBar.clientHeight}px`;
  } else {
    siteheader.classList.remove("siteheader--hideannouncement");
    announcementBar.style.marginTop = 0;
  }
};

const announcementBarInit = function () {
  // Get saved data from sessionStorage
  let closeannouncement = sessionStorage.getItem("key");

  if (closeannouncement) {
    siteheader.classList.add("siteheader--closeannouncement");
    return;
  }

  if (!announcementBar) {
    return;
  }

  document.addEventListener("scroll", announcementBarHide);
  window.addEventListener("resize", announcementBarHide);

  announcementCloseBtn.addEventListener("click", function (e) {
    e.preventDefault();
    siteheader.classList.add("siteheader--hideannouncement");
    announcementBar.style.marginTop = `-${announcementBar.clientHeight}px`;

    setTimeout(function () {
      siteheader.classList.add("siteheader--closeannouncement");
    }, 2000);

    // Save to sessionStorage
    sessionStorage.setItem("closeannouncement", "true");
  });
};
announcementBarInit();

/*  ==========================================================================
	FILTERS - OKRE HUB Filtering
	========================================================================== */

const filters = document.querySelector(".filters"),
  filtersToggle = document.querySelector(".filters__toggle"),
  filterSearchToggle = document.querySelector(".filters__search__toggle"),
  filterSearch = document.querySelector(".filters__search"),
  filterSearchInput = document.querySelector(".filters__search__input input");

const filterPageURL = filters ? filters.dataset.url : "";

let filtersInitialLoad = true;

// Get current from filters data

const filterGetFormData = function () {
  let filter_data = {};

  filter_settings.filters.forEach(function (el) {
    let checkedOptions = document.querySelectorAll('input[type="checkbox"][name=' + el.name + "]:checked");
    filter_data[el.name] = [...checkedOptions].map(x => x.value);
  });

  return filter_data;
};

const filterUpdateURL = function (filterData, searchData) {
  let url_params = "";

  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter_" + key + "=" + values;
    }
  }

  if (searchData) {
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "search=" + searchData;
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = filterPageURL + url_params;

  if (currentPageUrl !== filterPageURL) {
    window.location.href = newUrl;
  }

  if (currentPageUrl === filterPageURL && history.pushState) {
    window.history.pushState({ path: newUrl }, "", newUrl);
  }
};

// Toggles All Content checkbox if there is selected filters within the group
const filterSelectedAllCheckboxes = function (groupName) {
  let noActiveFiltersInGroup = true;

  document.querySelectorAll('input[type="checkbox"][name=' + groupName + "]").forEach(el => {
    if (el.checked === true) {
      noActiveFiltersInGroup = false;
    }
  });
  const allGroupCheckbox = document.querySelector('input[type="checkbox"][name=all_' + groupName + "]");
  if (allGroupCheckbox) {
    allGroupCheckbox.checked = noActiveFiltersInGroup;
  }
};

// Setup up the active tags in the filter bar
const filterAddingActiveTags = function (filterData) {
  let hasClassActive = false;
  // Reset styles
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  fieldsets.forEach(set => {
    set.classList.remove("filters__fieldset--active");
  });

  const fieldsetField = document.querySelectorAll(".filters__fieldset__field");
  fieldsetField.forEach(field => {
    field.classList.remove("filters__fieldset__field--active");
  });

  // Reset tags
  document.querySelector(".filters__tags").classList.remove("filters__tags--active");
  document.querySelector(".filters__activetags__tags").innerHTML = "";

  for (const [key, values] of Object.entries(filterData)) {
    if (values.length > 0) {
      // Make field group active
      document
        .querySelector(".filters__fieldset[data-value='" + key + "']")
        .classList.remove("filters__fieldset--active");

      for (const value of values) {
        // Make input field active

        let filter_input = document
          .querySelector("input[name='" + key + "'][value='" + value + "']")
          .closest(".filters__fieldset__field");

        filter_input.classList.add("filters__fieldset__field--active");
        // Show active tags
        document.querySelector(".filters__tags").classList.add("filters__tags--active");
        // Add tag
        let filter_input_name = filter_input.querySelector(".filters__fieldset__field__label").innerHTML;

        document.querySelector(
          ".filters__activetags__tags"
        ).innerHTML += `<div class="filters__tag" data-name="${key}" data-value="${value}">${filter_input_name} <i class="fas fa-times"></i></div>`;

        hasClassActive = true;
      }
    }

    filterSelectedAllCheckboxes(key);
  }

  return hasClassActive;
};

const filterGetPosts = function () {
  // Getting the forma data
  let filterData = filterGetFormData();
  let searchData = filterSearchInput.value;

  if (filterData || searchData) {
    // Update url
    filterUpdateURL(filterData, searchData);

    let activeTagsNotEmpty = filterAddingActiveTags(filterData);

    if ((filtersInitialLoad && (activeTagsNotEmpty || searchData)) || !filtersInitialLoad) {
      filtersInitialLoad = false;

      // If there's an active search, open the search field
      if (searchData) {
        document.querySelector(".filters__search").classList.add("filters__search--open");
      }

      // Start filtering
      document.querySelector(".posts.loadmore-container").classList.add("filtering");

      console.log(php_variables.posts);

      // Trigger ajax
      let data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filterData,
        search_data: searchData
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        beforeSend: function (xhr) {
          document.querySelector(".filters__apply").textContent = "Filtering...";
        },
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          let showingCounter = 0;

          // if (data.max_page === 1) {
          showingCounter = data.found_posts;
          // } else if (data.max_page > 1) {
          //   showingCounter = data.post_count;
          // }

          console.log(data.found_posts);
          console.log(data.args);

          document.querySelector(".posts__searchresult").innerText =
            data.post_count === 1 ? `Showing ${showingCounter} result` : `Showing ${showingCounter} results`;

          // change the button label back
          document.querySelector(".filters__apply").textContent = "Apply filter";

          // Hide the feature post section if there is one
          const featureposts = document.querySelector(".featurepost--contenthub");
          if (featureposts) {
            featureposts.classList.add("hidden");
          }

          // hide load more button, if there are not enough posts for the second page
          const pagingLoadmore = document.querySelector(".paging__loadmore");
          if (pagingLoadmore) {
            if (data.max_page < 2) {
              pagingLoadmore.style.display = "none";
            } else {
              pagingLoadmore.style.display = "block";
            }
          }

          // insert the posts to the container
          const loadmoreContainer = document.querySelector(".posts.loadmore-container");
          if (loadmoreContainer) {
            loadmoreContainer.innerHTML = data.content;

            // Finish filtering
            loadmoreContainer.classList.remove("filtering");
          }

          // Scroll to the top
          window.scrollTo({ top: 0, behavior: "smooth" });

          setFilterTagsListeners();

          lazyLoadInstance.update();
        },
        error: function (data) {}
      });
    }
  }
};

const setFilterTagsListeners = function () {
  const allFilterTags = document.querySelectorAll(".filters__tag");
  allFilterTags.forEach(tag => {
    tag.addEventListener("click", function () {
      let filter_name = tag.dataset.name;
      let filter_value = tag.dataset.value;
      let filter_input = (document.querySelector(
        "input[name='" + filter_name + "'][value='" + filter_value + "']"
      ).checked = false);
      // Remove tag
      tag.remove();
      // Trigger filter
      filterGetPosts();
    });
  });
};

const filterSetupClearAll = function () {
  const filterClearAll = document.querySelectorAll(".filters__clearall");
  filterClearAll.forEach(btn => {
    btn.addEventListener("click", function () {
      // Clear search
      filterSearchInput.value = "";
      filterSearch.classList.remove("filters__search--open");

      // Remove all tags
      document.querySelector(".filters__tags").classList.remove("filters__tags--active");
      document.querySelector(".filters__activetags__tags").innerHTML = "";
      // Uncheck all inputs
      const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input");
      filterCheckboxes.forEach(el => (el.checked = false));

      // Trigger filter
      filterGetPosts();

      filters.classList.remove("filters--searchopen");
      filters.classList.remove("filters--dropdownopen");
    });
  });
};

// Init Filter on posts pages
const filterInit = function () {
  let currentPageUrl = window.location.href.split("?")[0];

  const submitBtn = document.querySelector(".filters__apply");
  const filterForm = document.querySelector(".filters__form");

  if (filterForm && filterForm.length) {
    // Filter on page load only if we are on the /all posts page
    //Check if we are on posts pages or Okre Hub
    if (currentPageUrl === filterPageURL) {
      filterGetPosts();
    }

    // Dropdown open & close
    filtersToggle.addEventListener("click", function (e) {
      e.stopPropagation();
      filters.classList.remove("filters--searchopen");
      filters.classList.toggle("filters--dropdownopen");
    });

    //Closing filter if click elsewhere
    document.addEventListener("click", function (e) {
      if (e.target !== filters && !filters.contains(e.target)) {
        if (filters.classList.contains("filters--searchopen")) {
          filters.classList.remove("filters--searchopen");
        }
        if (filters.classList.contains("filters--dropdownopen")) {
          filters.classList.remove("filters--dropdownopen");
        }
      }
    });

    // Filter on submit
    filterForm.addEventListener("submit", function (e) {
      // Stop the form from submitting
      e.preventDefault();

      let currentPageUrl = window.location.href.split("?")[0];

      //Check if we are on posts pages or Okre Hub
      if (currentPageUrl !== filterPageURL) {
        let filterData = filterGetFormData();
        let searchData = filterSearchInput.value;

        // Update url
        filterUpdateURL(filterData, searchData);
      } else {
        // Call the filtering post function
        filterGetPosts();
        filters.classList.remove("filters--searchopen");
        filters.classList.remove("filters--dropdownopen");
      }
    });

    // Search open & close
    filterSearchToggle.addEventListener("click", function (e) {
      if (filterSearch.classList.contains("filters__search--open")) {
        filterSearch.classList.remove("filters__search--open");
      } else {
        filterSearch.classList.add("filters__search--open");
        filterSearchInput.focus();
      }
    });

    const filterCheckboxes = filterForm.querySelectorAll(".filters__fieldset__field input");

    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function (evt) {
        // Submit for on checkbox click
        //   filterGetPosts();
        //   filters.classList.toggle("filters--dropdownopen");

        // Setting the All Content/Subject checkbox functionality
        let groupName = evt.target.name.replace("all_", "");
        if (evt.target.checked) {
          if (evt.target.value !== "all") {
            document.querySelector('input[type="checkbox"][name=all_' + evt.target.name + "]").checked = false;
          } else {
            document
              .querySelectorAll('input[type="checkbox"][name=' + groupName + "]")
              .forEach(el => (el.checked = false));
          }
        } else {
          if (evt.target.value === "all") {
            evt.target.checked = true;
          } else {
            let activeFiltersInGroup = false;
            document.querySelectorAll('input[type="checkbox"][name=' + groupName + "]").forEach(el => {
              if (el.checked === true) {
                activeFiltersInGroup = true;
              }
            });
            if (!activeFiltersInGroup) {
              document.querySelector('input[type="checkbox"][name=all_' + groupName + "]").checked = true;
            }
          }
        }
      });
    });

    // Remove tags on click
    setFilterTagsListeners();

    // Clear all
    filterSetupClearAll();
  }
};

filterInit();
